/**
 * Scroll reveal: adds `is-intersecting` to `.intersection-trigger` elements once enough of them is on screen.
 *
 * The bar is visible pixels, capped by the viewport: an element reveals when
 * min(ratio × its height, MAX_REVEAL_PX, 20% of the viewport) of it is visible, so tall elements and short screens
 * always trigger. `intersection-ratio` (default 0.2) tunes it per element; members of an `intersection-group`
 * reveal together. Elements already scrolled past reveal at once, and everything shows immediately without
 * IntersectionObserver or with prefers-reduced-motion.
 */
(function() {
    var Intersection = {
        DEFAULT_INTERSECTION_RATIO : 0.2,
        MAX_REVEAL_PX : 120,

        observer : null,
        groups : {},

        reveal : function(element) {
            var key = element.getAttribute('intersection-group');
            var members = key && this.groups[key] ? this.groups[key] : [element];
            for ( var i = 0; i < members.length; i++ ) {
                members[i].classList.add('is-intersecting');
                if ( this.observer ) {
                    this.observer.unobserve(members[i]);
                }
            }
        },

        handleIntersection : function(entries) {
            for ( var i = 0; i < entries.length; i++ ) {
                var entry = entries[i];
                if ( entry.target.classList.contains('is-intersecting') ) {
                    continue;
                }
                // Scrolled past (anchor jump, restored scroll position): show it rather than leave a hidden gap.
                if ( entry.boundingClientRect.bottom <= 0 ) {
                    this.reveal(entry.target);
                    continue;
                }
                if ( !entry.isIntersecting ) {
                    continue;
                }
                var ratio = parseFloat(entry.target.getAttribute('intersection-ratio'));
                if ( isNaN(ratio) ) {
                    ratio = this.DEFAULT_INTERSECTION_RATIO;
                }
                var viewportHeight = entry.rootBounds ? entry.rootBounds.height : window.innerHeight;
                var needed = Math.min(ratio * entry.boundingClientRect.height, this.MAX_REVEAL_PX, viewportHeight * 0.2);
                if ( entry.intersectionRect.height >= needed ) {
                    this.reveal(entry.target);
                }
            }
        },

        /** Register the triggers under `root` (default: the document); call again for content added later. */
        observe : function(root) {
            var triggers = (root || document).querySelectorAll('.intersection-trigger:not(.is-intersecting)');
            for ( var i = 0; i < triggers.length; i++ ) {
                var trigger = triggers[i];
                var key = trigger.getAttribute('intersection-group');
                if ( key ) {
                    this.groups[key] = this.groups[key] || [];
                    if ( this.groups[key].indexOf(trigger) === -1 ) {
                        this.groups[key].push(trigger);
                    }
                }
                if ( this.observer ) {
                    this.observer.observe(trigger);
                } else {
                    trigger.classList.add('is-intersecting');
                }
            }
        },

        init : function() {
            var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if ( 'IntersectionObserver' in window && !reduceMotion ) {
                this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
                    rootMargin : '0px 0px -8% 0px',
                    threshold : [0, 0.05, 0.1, 0.25, 0.5, 0.75, 1]
                });
            }
            this.observe(document);
        }
    }

    window.wghi.Intersection = Intersection;

    document.addEventListener('DOMContentLoaded', function() {
        window.wghi.Intersection.init();
    })
})();
